import React from "react";
import { Navigate } from "react-router-dom";
import permissionsService from "../../services/permissionsService";

interface PermissionGuardProps {
  children: React.ReactNode;
  requiredRoles?: string[];
  requiredPermissions?: string[];
}

export default function PermissionGuard({
  children,
  requiredRoles = [],
  requiredPermissions = [],
}: PermissionGuardProps) {
  const { hasRole, hasPermission } = permissionsService();

  const rolesPass =
    requiredRoles.length === 0 || requiredRoles.some((role) => hasRole(role));

  const permsPass =
    requiredPermissions.length === 0 ||
    requiredPermissions.every((perm) => hasPermission(perm));

  // Debug logging for development
  if (process.env.NODE_ENV === 'development' && requiredRoles.length > 0) {
    console.log('[PermissionGuard] Access check:', {
      requiredRoles,
      rolesPass,
      requiredPermissions,
      permsPass,
      willAllow: rolesPass && permsPass
    });
  }

  if (!rolesPass || !permsPass) {
    // Log access denial in development
    if (process.env.NODE_ENV === 'development') {
      console.warn('[PermissionGuard] Access denied:', {
        requiredRoles,
        rolesPass,
        requiredPermissions,
        permsPass
      });
    }
    return <Navigate replace to="/403" />;
  }

  return <>{children}</>;
}
